module.exports = __webpack_public_path__ + "static/media/6.29cbf93a.mp3";